import React from "react";
import { useI18n } from "./i18n";
import { BILLING_INTERVALS, formatPrice, pricing } from "./pricing";
import { recordingMinutes, useConversionCopy } from './conversionCopy';

export default function UpgradeBillingActions({
  onUpgrade,
  className = "",
  annualLabel,
  monthlyLabel,
  signupFirst = false,
  record = null,
  limitKind = null,
  disabled = false,
}) {
  const { t } = useI18n();
  const copy = useConversionCopy();
  const minutes = recordingMinutes(record);
  const size = Number(record?.size_bytes);
  const dailyLimit = limitKind === 'daily_limit';
  const rootClassName = ["upgrade-billing-actions", className].filter(Boolean).join(" ");
  const monthlyPrice = formatPrice(pricing.monthlyProPrice);
  const annualMonthlyPrice = formatPrice(pricing.annualProMonthlyPrice);
  const annualTotal = formatPrice(pricing.annualProTotalPrice);

  const handleClick = (event, interval) => {
    event.stopPropagation();
    onUpgrade?.(interval);
  };

  return (
    <div className={rootClassName} role="group" aria-label={t("billing.intervalLabel")}>
      {(record || dailyLimit) && <div className="upgrade-record-context">
        {record?.original_filename && <strong className="upgrade-record-name">{record.original_filename}</strong>}
        {minutes && <p>{copy.recordingDuration(minutes)}</p>}
        {minutes > 35 && <p>{copy.freeDuration}</p>}
        {Number.isFinite(size) && size > 50 * 1024 * 1024 && <p>{copy.recordingSize(Math.ceil(size / 1024 / 1024))}. {copy.freeSize}</p>}
        {dailyLimit && <p>{copy.dailyLimit}</p>}
      </div>}
      <button
        type="button"
        disabled={disabled}
        className="upgrade-billing-action upgrade-billing-action--monthly"
        onClick={(event) => handleClick(event, BILLING_INTERVALS.MONTHLY)}
      >
        {monthlyLabel || (dailyLimit ? copy.continueToday : record?.id ? copy.entireFile : copy.continuePremium)}
      </button>
      <span className="upgrade-action-note upgrade-monthly-price"><strong>{monthlyPrice}{t('billing.perMonth')}</strong> · {t('billing.billedMonthly')}</span>
      {signupFirst && <span className="upgrade-action-note">{t("billing.signupPremiumHint")}</span>}
      {record?.retained === true && <span className="upgrade-action-note">{record.retained_locally?copy.fileSavedLocally:copy.fileSaved}</span>}
      {record?.retained === false && <span className="upgrade-action-note">{copy.fileReselect}</span>}
      <details className="upgrade-annual-option">
      <summary>{t("billing.saveWithAnnual", { percent: pricing.annualDiscountPercent })}</summary>
      <button
        type="button"
        disabled={disabled}
        className="upgrade-billing-action upgrade-billing-action--annual"
        onClick={(event) => handleClick(event, BILLING_INTERVALS.ANNUAL)}
      >
        {annualLabel || t('billing.billedAnnual', { annualTotal })}
      </button>
      <span className="upgrade-action-note">{annualMonthlyPrice}{t('billing.perMonth')} · {t("billing.billedAnnual", { annualTotal })}</span>
      </details>
    </div>
  );
}
